import type { PageContainer } from "@judo/model-api";
import { PageContainerType } from "@judo/model-api";

/**
 * Resolve the effective container type.
 * In EMF/ECore, default enum values are not serialized.
 * Since TABLE is the first literal (value 0), it's the default when type is not present.
 *
 * Separated from PageRenderer.tsx to preserve HMR boundaries.
 * See: specs/HMR.md — Standard I: Single-Authority Export Mandate
 */
export function resolveContainerType(container: PageContainer): PageContainerType {
	// When type is explicitly set in the model, use it
	if (container.type) {
		return container.type;
	}
	// When type is not present, it means TABLE (the EMF default)
	return PageContainerType.TABLE;
}
